module.exports = __webpack_public_path__ + "img/login-logo-kh.16ffe7ca.png";